export const orderFormData = () => ({
  inputData: {
    type: null,
    subcontractor_role: null,
    company_name: null,
    contact_person_name: null,
    contact_person_email: null,
    mobile_number: null,
    alt_mobile_number: null,
    gst_no: null,
    pan_no: null,
    address: null,
    is_active:true,
    documents: [
      {
        document: "",
        file: "",
        is_active:true
      },
    ],
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "company_masters",
    relation: [
      {
        modelName: "company_documents",
        moduleAs: "documents",
        foreignKey: "company_id",
      },
    ],
  };

  const navigatePage = { back: "/subcontractor-customer-list" };

  const headerName = "Subcontractor & Customer";

  const validationType = "subcontractorAndCustomerCreate";
  const createEndpoint = "/updaterelationaldata";
  const getUpdateEndpoint = "/updaterelationaldata";

  const userType = [
    { label: "Subcontractor", value: 1 },
    { label: "Customer", value: 2 },
  ];
  const subcontractorRole = [
    { label: "Bermad", value: 1 },
    { label: "Customer", value: 2 },
  ];

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    getUpdateEndpoint,
    userType,
    subcontractorRole,
  };
};
